import { render, staticRenderFns } from "./RatingAdminDirectionsIndexRootView.vue?vue&type=template&id=4d61b50a"
import script from "./RatingAdminDirectionsIndexRootView.vue?vue&type=script&lang=js"
export * from "./RatingAdminDirectionsIndexRootView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports